
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

import { getProvince, getCity, getCounty } from '@/api/sys.js'
import icoadd from '@/assets/ico-add.png'
import icoSorry from '@/assets/ico-sorry.png'
import {
editAddress,
removeAddress,
getAddress,
getAddressDefault
} from '@/api/user.js'
import Storage from '@/storage'
export default {
name: 'address',
data () {
return {
addressList: [],
ischeck: this.$route.params.ischeck,
addressObj: {
ADDRESS: '',
CITYIDNAME: '',
COUNTYIDNAME: '',
ID: '',
ISDEFAULT: '',
MOBILE: '',
NAME: '',
PROVINCEIDNAME: ''
},
isdefault: false,
ispopurShow: false,
addressDefault: {},
addressID: '',
addressValue: [],
countrylist: [],
countyid: '',
isEditshow: false,
icoadd: icoadd,
icoSorry: icoSorry,
selected: ''
}
},
components: {
Popup,
Group,
Cell,
XInput,
Selector,
PopupRadio,
XAddress,
XTextarea,
XSwitch,
Flexbox,
FlexboxItem,
XButton,
Checker,
CheckerItem
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
methods: {
goedit (item) {
this.$router.push({ name: 'addressAdd', params: { ID: item.ID } })
},
addAddress () {
this.$router.push({ name: 'addressAdd', params: { ID: 0 } })
},
getAddressList () {
getAddress({
accountid: this.accountid,
userid: this.userid
}).then(res => {
if (res.returnValue && res.returnValue.length > 0) {
this.addressList = res.returnValue
}
})
},
onChange (value, disabled) {
this.$store.commit('setAddress', {
ADDRESS: value.ADDRESS,
CITYID: value.CITYID,
CITYIDNAME: value.CITYIDNAME,
COUNTYID: value.COUNTYID,
COUNTYIDNAME: value.COUNTYIDNAME,
ID: value.ID,
ISDEFAULT: value.ISDEFAULT,
MOBILE: value.MOBILE,
NAME: value.NAME,
PROVINCEID: value.PROVINCEID,
PROVINCEIDNAME: value.PROVINCEIDNAME
})
},
add () {
if (this.addressObj.NAME === '') {
this.$vux.toast.text('请填写姓名', 'middle')
return false
}
if (this.addressObj.MOBILE === '') {
this.$vux.toast.text('请填写电话', 'middle')
return false
}
if (!/^1(3|4|5|7|8|9)\d{9}$/.test(this.addressObj.MOBILE)) {
console.log(this.addressObj)
this.$vux.toast.text('手机号码格式不对哦～', 'middle')
return false
}
if (this.addressValue.length === 0) {
this.$vux.toast.text('请选择所在省地市', 'middle')
return false
}
if (this.addressObj.ADDRESS === '') {
this.$vux.toast.text('请填写详细地址', 'middle')
return false
}
if (this.isdefault) {
this.addressObj.isdefault = 1
} else {
this.addressObj.isdefault = 2
}
editAddress({
addressid: this.addressObj.ID,
accountid: this.accountid,
address: this.addressObj.ADDRESS,
isdefault: this.addressObj.isdefault,
provinceid: '31', // this.addressObj.provinceid,
cityid: '6', // this.addressObj.cityid,
countyid: this.countyid, // this.addressObj.countyid,
name: this.addressObj.NAME,
mobile: this.addressObj.MOBILE,
openid: this.openid
}).then(res => {
this.$vux.toast.text('地址修改成功', 'middle')
this.isEditshow = false
this.getAddressList()

})
},
sure () {
if (this.selected === '') {
this.$vux.toast.text('您还没有选择地址！', 'middle')
} else {
this.$emit('changeingType', 'false')
}
}
},
activated () { },
created () {
this.getAddressList()
}
}
